<div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="5px" style="padding: 5px 0 0 5px">
  <!-- Prévisualisation du formulaire, vue demandeur et le cadre administratif le cas échénat -->
  <mat-progress-bar [mode]="'indeterminate'" *ngIf="loading"></mat-progress-bar>
  <div *ngIf="formModel$ | async as formModel" fxFlex="{{widthForm()}}">
    <mat-card>
      <mat-card-title>
        <p8-layout-settings-header [titlePath]="[titlePath(formModel)]"></p8-layout-settings-header>
      </mat-card-title>
      <mat-card-content>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
          <mat-tab label="Vue demandeur">
            <app-form-render
              [canSave]="false"
              [formModel]="formModel"
              [submitted]="submitted"
            ></app-form-render>
          </mat-tab>
          <mat-tab label="Vue suivi administratif" *ngIf="hasAdministrativeBlock(formModel)">
              <div>
                <app-form-render
                  [canSave]="false"
                  [formModel]="formModel"
                  [blockType]="blockType.Administratif"
                  [submitted]="false"
                ></app-form-render>
              </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
  <!-- cadre de gestion : statut, lien, gestionnaires -->
  <div *ngIf="displayManagement && formModel$ | async as formModel"
       fxLayout="row">
    <div fxFlex="20" class="sticky__content">
      <mat-card *ngIf="isGestionnaire()">
        <mat-card-content>
          <mat-card *ngIf="formModel.state === formState.published && (formModel?.url_obj && formModel?.url_obj.length > 0 && formModel?.url_obj[0])" style="margin-bottom: 5px;">
            <mat-card-title>Lien public de réponse à envoyer</mat-card-title>
            <mat-card-content>
              <span>
                Cliquer sur <button mat-icon-button (click)="openLink(formModel)" color="warn"><mat-icon>link</mat-icon></button> pour l'obtenir
              </span>
            </mat-card-content>
          </mat-card>
          <mat-card style="margin-bottom: 5px;">
            <mat-card-title>Etat du formulaire</mat-card-title>
            <mat-card-content>
              <app-form-states *ngIf="isGestionnaire()"
                               [form]="formModel"
                               [align]="'start'"></app-form-states>
            </mat-card-content>
          </mat-card>
          <mat-card style="margin-bottom: 5px;">
            <mat-card-title>Gérer par</mat-card-title>
            <mat-card-content>
              <app-gestionnaires-list fxFlex="75" [formModel]="formModel" [canDelete]="false"></app-gestionnaires-list>
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
